import {useState, Component} from 'react';

import Dropdown from '../../../components/dropdowns/dropdown';
import Input from '../../../components/input-with-label';
import TextArea from '../../../components/textarea-with-label';
import Checkbox from '../../../components/checkbox';
import RadioButton from '../../../components/radio-button';
import InputCurrency from '../../../components/input-currency';

import {SmallPill} from '../../../components/pills';

import ApplicationHeader from '../grants-application-header';
import ApplicationSection from '../grants-application-section';

import ButtonPrevious from '../../../components/buttons-navigation/button-previous';
import ButtonNext from '../../../components/buttons-navigation/button-next';

import questionChunk from "../../../lib/applications/question-chunk";

import Table from '../../../components/table/table';

import FileUploader from '../../../components/popups/images/file-uploader-popup';

import { stringToFriendlyDatetime } from '../../../lib/helpers/datetime-helpers';

import FileTypes from '../../../lib/files/file-types';
import he from 'he';

import {
    SaveButton,
    UploadButton,
    UploadDocumentButton,
    ProceedButton,
    CommentButton
} from '../../../components/buttons';

import ApplicationApi from '../../../lib/applications/application-api';

import AlertManager from '../../../managers/alert/alert-manager';

import Chatbox from '../../../components/chatbox/chatbox';

import QuestionTypeInput from '../question-types/question-type-text-input';
import QuestionTypeDatePicker from '../question-types/question-type-date-picker';
import QuestionTypeDropdown from '../question-types/question-type-dropdown';
import QuestionTypeCurrencyInput from '../question-types/question-type-currency-input';
import QuestionTypeTable from '../question-types/question-type-table';
import QuestionTypeUploadDocs from '../question-types/question-type-upload-documents';
import QuestionTypeCheckboxes from '../question-types/question-type-checkboxes';
import QuestionTypeRadioButtons from '../question-types/question-type-radio-buttons';
import QuestionTypeSicCode from '../question-types/question-type-sic-code';

import QuestionTypes from '../question-types/question-types';

import ConfirmPopup from './grants-summary-confirm';

import MediaQuery from 'react-responsive';
import StickyContainer from "../../../components/layout/sticky-container";

import DOMPurify from 'dompurify';

const fileTypes = [
    FileTypes.PDF,
    FileTypes.TXT,
    FileTypes.DOC,
    FileTypes.DOCX,
    FileTypes.XLSX,
    FileTypes.CSV,
    'image/jpeg',
    'image/png'
]

const STATUS_OFFER_LETTER_SENT = 'offer letter sent';
const STATUS_AWAITING_DOCUMENTS = 'awaiting documents';
const STATUS_CLAIM_PROCESSED = 'claim processed';
const STATUS_PROGRESS = 'in progress';
const STATUS_PENDING = 'pending';
const STATUS_APPROVED = 'approved';
const STATUS_REJECTED = 'rejected';
const STATUS_SCORING = 'scoring';
const STATUS_AMENDMENTS_REQUIRED =  'amendments required';
const STATUS_OFFER_ACCEPTED = 'offer accepted';
const STATUS_OFFER_REJECTED = 'offer rejected';
const STATUS_DOCUMENTS_REQUESTED = 'documents requested';
const STATUS_DOCUMENTS_RECEIVED = 'documents received';
const STATUS_CLAIM_SUBMITTED_FOR_PAYMENT = 'claim submitted for payment';
const STATUS_COMPLETED = 'completed';
const STATUS_CLAIM_APPROVED_FOR_PAYMENT = 'claim approved for payment';

export default class GrantsApplicationSummary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedSection: 0,
            total_grant_value_requested: null,
            confirmation: false,
            showChatbox: false,
            question: null,
            comments: [],
            amends: [],
            values: [],
            validation: [],
            confirmPopup: false,
            showDocuments: false,
            currentAmends: 0,
            currentValues: 0,
        }

        this.questionTypes = {
            'text-input': QuestionTypeInput,
            'dropdown-selection': QuestionTypeDropdown,
            'radio-buttons': QuestionTypeRadioButtons,
            'date-picker': QuestionTypeDatePicker,
            'checkboxes': QuestionTypeCheckboxes,
            'currency-input': QuestionTypeCurrencyInput,
            'table-input': QuestionTypeTable,
            'upload-documents': QuestionTypeUploadDocs,
            'sic-code': QuestionTypeSicCode,
        }

        this.states = [
            STATUS_APPROVED,
            STATUS_REJECTED,
            STATUS_OFFER_LETTER_SENT,
            STATUS_OFFER_ACCEPTED,
            STATUS_CLAIM_PROCESSED,
            STATUS_OFFER_REJECTED,
            STATUS_DOCUMENTS_REQUESTED,
            STATUS_DOCUMENTS_RECEIVED,
            STATUS_CLAIM_SUBMITTED_FOR_PAYMENT,
            STATUS_COMPLETED,
            STATUS_CLAIM_APPROVED_FOR_PAYMENT
        ];

        this.api = new ApplicationApi();
    }

    componentDidMount() {
        this.fetchComments();
        this.fetchAmends();
    }

    fetchComments() {
        this.api.getComments(this.props.application.id).then(({data}) => {
            this.setState({comments: data})
        });
    }

    fetchAmends(callback = () => {
    }) {
        this.api.getAmends(this.props.application.id).then((data) => {
            const {length} = data.filter(amend => amend.archived == 0 && amend.response == null && amend.responded_by == null);
            const amends = length !== 0 ? length : null;

            this.setState({amends: data});
            this.props.setAmends(amends);

            callback();
        });
    }

    setSelectedSection(index) {
        this.setState({selectedSection: index});
    }

    setShowDocuments(bool) {
        this.setState({ showDocuments: bool })
    }

    setConfirmation(e) {
        const {value} = e;

        this.setState({confirmation: value})
    }

    setTotalGrantValue(e) {
        const {value} = e.target;

        this.setState({total_grant_value_requested: Number(value)})
    }

    onSubmit() {

        if (!this.state.confirmation) return;

        this.props.onSubmit();
    }

    onAmendValueChange(amendId, e) {
        const {value} = e.target;
        const values = [...this.state.values];
        const amend = values.find(({id}) => id == amendId);

        if (amend) {
            amend.value = value;
        } else {
            values.push({id: amendId, value})
        }

        this.setState({values}, () => {

        })
    }

    onChange(amendId, e) {
        this.onAmendValueChange(amendId, {target: {value: e}})
    }

    onDropdownChange(amendId, e) {
        let {label, value} = e.hasOwnProperty('value') ? e : e.target;

        if (label) return this.onAmendValueChange(amendId, {target: {value: label}});

        this.onAmendValueChange(amendId, {target: {value}})
    }

    onTableChange(amendId, e) {
        const {value} = e;

        this.onAmendValueChange(amendId, {target: {value}})
    }

    onFileChange(amendId, e) {
        let {value} = e.hasOwnProperty('value') ? e : e.target;

        this.onAmendValueChange(amendId, {target: {value}})
    }

    onConfirmClick() {
        const currentAmends = this.state.amends.filter(amend => amend.archived == 0 && amend.response == null && amend.responded_by == null).length;
        const currentValues = this.state.values.length;

        this.setState({
            currentAmends,
            currentValues
        })

        this.setConfirmPopup(true);
    }

    onConfirmChanges() {
        this.api.submitAmends(this.props.application.id, {
            responses: this.state.values,
        }, errors => {

            this.fetchAmends(() => {
                this.setConfirmPopup(false);
                this.setConfirmPopup(false);
                this.setState({
                    values: []
                });
            });

            if(Array.isArray(errors)) {
                AlertManager.error(errors[0]);
            }else {
                AlertManager.error('These amends could not be submitted at this time');
            }


        }).then(() => {
            this.props.getApplication();

            this.fetchAmends(() => {
                this.setConfirmPopup(false);

                this.setState({
                    values: []
                })

                AlertManager.success('Successfully amended the application');
            });
        });
    }

    addError(errorBoolean, errors, sectionId, questionId) {
        let state = this.state.validation;

        if (errorBoolean) {
            const val = state.find(s => s.question_id == questionId);

            if (val) {
                val.errors = errors;
            } else {
                state.push({
                    question_id: questionId,
                    errors: errors
                });
            }
        } else {
            state = state.filter(s => s.question_id !== questionId);
        }

        this.setState({validation: state})
    }

    formatValue(question, value) {
        const hasAmend = this.state.amends.filter(amend => amend.question_id == question.id && amend.archived == 0 && amend.response == null && amend.responded_by == null)[0];
        const error = this.state.validation.find(v => v.question_id == question.id)?.errors || [];

        const Component = this.questionTypes[question.type] || TextArea;

        const amend = hasAmend ? this.state.values.find(({id}) => id == hasAmend.id) : null;
        const amendValue = amend ? amend.value : value;

        let val = value;

        let params = {
            value: amendValue,
            label: '',
        }

        let componentParams = {
            question,
            params,
            error,
            showErrors: true,
            sectionId: 0,
            blockId: 0,
            getQuestionValue: () => amendValue,
            addError: this.addError.bind(this)
        }

        if (question.type == QuestionTypes.DATE_PICKER) {
            let val = value;

            if (hasAmend) {
                return <Component onChange={(e) => this.onChange(hasAmend.id, e)} {...componentParams}/>
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            if (Array.isArray(value)) {
                val = value.join(' - ')
            }

            return val;
        }

        if (question.type == QuestionTypes.SIC_CODE) {
            if (hasAmend) {
                return <Component onChange={(e) => this.onDropdownChange(hasAmend.id, e)} {...componentParams}/>
            }

            if (Array.isArray(value)) {
                value = value.join(', ')
            }

            return <p>{String(value)}</p>;
        }

        if (question.type == QuestionTypes.DROPDOWN_SELECTION) {
            if (hasAmend) {
                return <Component onChange={(e) => this.onDropdownChange(hasAmend.id, e)} {...componentParams}/>
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            return <p>{String(value)}</p>;
        }

        if (question.type == QuestionTypes.UPLOAD_DOCUMENTS) {
            let val = value?.file?.name || '';

            if (hasAmend) {
                return <Component onChange={(e) => this.onFileChange(hasAmend.id, e)} {...componentParams}
                                  applicationId={this.props.application.id}/>
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            if (Array.isArray(value)) {
                let val = '';

                if (value.length > 0) {
                    const files = value.map(val => val.file.name);

                    val = String(files.join(', '))
                }

                return <p>{val}</p>
            }

            return <p>{val}</p>;
        }

        if (question.type == QuestionTypes.TEXT_INPUT) {
            if (hasAmend) {
                return <Component onChange={(e) => this.onAmendValueChange(hasAmend.id, e)} {...componentParams}/>
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            const decoded = he.decode(value);
            const sanitized = DOMPurify.sanitize(decoded, {
                FORBID_TAGS: ['img', 'video', 'picture',' audio', 'iframe'],
                FORBID_ATTR: ['href']
            });

            return <p style={{ width: '100%' }} className="markdown" dangerouslySetInnerHTML={{ __html: sanitized }}></p>
        }

        if (question.type == QuestionTypes.CURRENCY_INPUT) {
            const currency = question.currency;

            if (hasAmend) {
                return <Component onChange={(e) => this.onAmendValueChange(hasAmend.id, e)} {...componentParams}/>
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            return <p className="grants-application-row-item__content">{currency == 'GBP' ? '£' : '€'} {value}</p>
        }

        if (question.type == QuestionTypes.RADIO_BUTTONS) {
            if (hasAmend) {
                return <Component onChange={(e) => this.onChange(hasAmend.id, e)} {...componentParams} />
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            return (value || []).map((option) => <RadioButton text={option} checked={true} disabled={true}/>)
        }

        if (question.type == QuestionTypes.CHECKBOXES) {
            if (hasAmend) {
                return <Component onChange={(e) => this.onChange(hasAmend.id, e)} {...componentParams} />
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            return (value || []).map((option) => <Checkbox text={option} checked={true} disabled={true}/>)
        }

        if (question.type == QuestionTypes.TABLE_INPUT) {
            if (hasAmend) {
                return <Component onChange={(e) => this.onTableChange(hasAmend.id, e)} {...componentParams}/>
            }

            if (value == null || value.length == 0) {
                return <p>No Response</p>
            }

            return <Table columns={question.columns}
                          allowNewRows={question.allow_new_rows}
                          defaultRowCount={question.default_row_count}
                          maxRowCount={question.max_row_count}
                          onChange={() => {
                          }}
                          value={value}
                          readOnly={true}/>
        }

        return <p className="grants-application-row-item__content">{String(value)}</p>
    }

    getStatus() {
        return this.states.includes(this.props.application.status);
    }

    hasStatus(states) {
        return states.includes(this.props.application.status);
    }

    isInProgress() {

        return STATUS_PROGRESS === this.props.application.status;
    }

    requiresAmending() {
        return this.state.amends.filter(amend => amend.response == null && amend.responded_by == null).length > 0 ? this.state.validation.length == 0 : false;
    }

    setChatbox(showChatbox, question) {

        this.setState({
            showChatbox,
            question
        });
    }

    renderQuestion(question, status, section, block) {
        const questionValue = this.props.getQuestionValue(section.id, block.id, question.id);
        const comments = this.state.comments.filter(comment => comment.question_id == question.id);

        const unread = comments.filter(comment => {
            return comment.read_by == null && comment.read_by_id == null && (comment.user.super_admin == 1 || comment.user.admin == 1)
        })

        const justQuestionAmends = this.state.amends.filter(amend => amend.question_id == question.id);
        const questionAmends = this.state.amends.filter(amend => amend.question_id == question.id && amend.archived == 0 && amend.response == null && amend.responded_by == null);
        const latestAmend = justQuestionAmends[justQuestionAmends.length - 1];

        const hasAmend = questionAmends.length > 0 ? questionAmends[0] : false;

        return (
            <div className={`grants-application-row__item ${hasAmend ? 'amend__item' : ''}`}>
                { (question.title || question.description || justQuestionAmends.length > 0) &&
                    <div className="grants-application-row-item__head">
                        { question.title && <p className="grants-application-row-item__title">{block.show_question_decimal_number === true ? `${question.number}) ` : ''}{question.title}</p> }
                        { justQuestionAmends.length > 0 &&
                            <span className="grants-application-amend__pill">
                                {
                                    latestAmend.responded_at !== null &&
                                    <>
                                        Amended
                                        at {stringToFriendlyDatetime(latestAmend.responded_at)} by {latestAmend.responded_by.name}
                                    </>

                                }
                                {
                                    latestAmend.responded_at === null &&
                                    <>
                                        Amend requested
                                        at {stringToFriendlyDatetime(latestAmend.created)} by {latestAmend.created_by.name}
                                    </>

                                }

                            </span>}
                        { question.description && <p className="grants-application-row-item__description" dangerouslySetInnerHTML={{  __html: question.description }}></p> }
                    </div>
                }
                <div className="utils__row utils__gap--20" style={{ height: 'unset' }}>
                    { this.formatValue(question, questionValue) }
                </div>
                {this.props.application.status !== 'in progress' && comments.length > 0 && <div className="utils__row">
                    {comments.length > 0 ? unread.length > 0 ?
                        <CommentButton type="unread"
                                       onClick={() => this.setChatbox(true, question)}>{unread.length} unread
                            comment(s)</CommentButton> :
                        <CommentButton
                            onClick={() => this.setChatbox(true, question)}>{comments.length} Comments</CommentButton> : ''}
                </div>}
            </div>
        )
    }

    setConfirmPopup(bool) {
        this.setState({confirmPopup: bool});
    }

    onSectionChange(e) {
        const {value} = e;

        this.setSelectedSection(value);
    }

    render() {
        const {selectedPage, sections, backClick} = this.props;
        const section = sections[this.state.selectedSection];
        const status = this.getStatus();

        const mappedSections = sections.map((section, index) => ({
            label: section.name,
            value: index,
        }));

        return (
            <>
                {this.state.showChatbox &&
                <Chatbox application={this.props.application}
                         question={this.state.question}
                         setPopup={this.setChatbox.bind(this)}
                         fetchComments={this.fetchComments.bind(this)}/>}

                {this.state.confirmPopup &&
                <ConfirmPopup setPopup={this.setConfirmPopup.bind(this)} amends={this.state.currentAmends}
                              amended={this.state.currentValues} confirm={this.onConfirmChanges.bind(this)}/>}

                <FileUploader toggled={this.state.showDocuments} onlyShow={['browse', 'upload']}
                              onClose={() => this.setShowDocuments(false)}
                              readOnly={true}
                              params={{
                                  path : `/applications/${this.props.application.id}/files`,
                              }}
                              path={`/applications/${this.props.application.id}/files`}
                              endpoint={`/api/connector/file-upload`}
                              fileTypes={fileTypes}
                />

                <ApplicationHeader title={<>
                    <div className="state-pages-header__row">
                        <h2 className="state-pages-header__title">Summary of Application</h2>
                    </div>
                    {status &&
                    <div className="state-pages-header__row">
                        <div className="utils__row utils__gap--20">
                            <div className="information-outer">
                                <p className="information-outer__title">Application Output</p>
                                <UploadDocumentButton onClick={() => window.location = `/myeb/grants/applications/${this.props.application.id}/pdf`}>Export as PDF</UploadDocumentButton>
                            </div>
                            { this.hasStatus([STATUS_REJECTED, STATUS_OFFER_REJECTED, STATUS_COMPLETED]) === false &&
                                <div className="information-outer">
                                    <p className="information-outer__title">Documents</p>
                                    <UploadDocumentButton onClick={() => this.setShowDocuments(true)}>Document Uploads</UploadDocumentButton>
                                </div>
                            }
                        </div>
                    </div>
                    }
                </>
                } subtitle={<div className="state-pages-header__row">
                    <h2 className="state-pages-header__subtitle">
                        {this.props.application.name ? `Grant Application Name: #${this.props.application.name.toUpperCase()}` : ''}</h2>
                </div>}>

                </ApplicationHeader>

                <div className="state-pages__content">
                     <div className="state-pages__navigation-pills">
                            <MediaQuery maxWidth={568}>
                                <Dropdown items={mappedSections} value={mappedSections[this.state.selectedSection].label} onChange={this.onSectionChange.bind(this)}/>
                            </MediaQuery>

                            <MediaQuery minWidth={569}>
                                {sections.map((section, index) => {
                                    let unreadComments = []
                                    let sectionAmends = []
                                    let sectionComments = [];
                                    let sectionAllAmends = [];


                                    section?.blocks.forEach((block) => {
                                        const questionComments = this.state.comments
                                            .filter((comment) => block.questions.find(bq => bq.id == comment.question_id));

                                        sectionComments = [...sectionComments, ...questionComments];

                                        const unreadQuestionComments = questionComments.filter((comment) => comment.read_by == null && comment.read_by_id == null && (comment.user.super_admin == 1 || comment.user.admin == 1));
                                        unreadComments = [...unreadComments, ...unreadQuestionComments];


                                        const questionWithAmends = block.questions.filter((question) => this.state.amends.find(amend => amend.question_id === question.id));

                                        questionWithAmends.forEach(question =>{
                                            const amends = this.state.amends.filter(amend => {
                                                return (amend.question_id === question.id && amend.response == null && amend.responded_by == null)
                                            });

                                            amends.forEach(amend => sectionAmends.push(amend));
                                        });


                                        sectionAllAmends = [...sectionAllAmends, ...questionWithAmends];
                                    });



                                    return <SmallPill onClick={() => this.setSelectedSection(index)}>
                                        <div className={'small-pill__inner'}>
                                            { (sectionComments.length >= 1 || sectionAllAmends.length >= 1)  &&
                                            <div className="pill__spans">
                                                {sectionComments.length > 0 &&
                                                <div
                                                    className={`small-pill__span-item ${unreadComments.length >= 1 ? 'small-pill__span-item--with-margin' : ''}`}>
                                                    <svg className={'small-pill__icon'} data-name="Group 1025"
                                                         xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                                         viewBox="0 0 15 15">
                                                        <path id="Path_379" data-name="Path 379" d="M0,0H15V15H0Z"
                                                              fill="none"/>
                                                        <path id="Path_380" data-name="Path 380"
                                                              d="M11.929,5.121a3.168,3.168,0,0,0,1.889.224V11.45a.572.572,0,0,1-.591.55H2.591A.572.572,0,0,1,2,11.45V2.65a.572.572,0,0,1,.591-.55h7.741a2.564,2.564,0,0,0-.059.55,2.629,2.629,0,0,0,.7,1.783L7.945,6.876,4.155,3.881l-.765.838L7.952,8.324Zm1.3-.821a1.715,1.715,0,0,1-1.773-1.65A1.777,1.777,0,0,1,15,2.65,1.715,1.715,0,0,1,13.227,4.3Z"
                                                              fill="#fff"/>
                                                    </svg>
                                                    {
                                                        unreadComments.length >= 1 &&
                                                        <div className={'small-pill__span-item-counter'}>
                                                            {unreadComments.length}
                                                        </div>
                                                    }

                                                </div>
                                                }
                                                {
                                                    sectionAllAmends.length > 0 &&
                                                    <div
                                                        className={`small-pill__span-item ${sectionAmends.length >= 1 ? 'small-pill__span-item--with-margin' : ''}`}>

                                                        <svg className={'small-pill__icon'} id="Group_1027"
                                                             data-name="Group 1027"
                                                             xmlns="http://www.w3.org/2000/svg" width="16.133"
                                                             height="16.133" viewBox="0 0 16.133 16.133">
                                                            <path id="Path_358" data-name="Path 358"
                                                                  d="M0,0H16.133V16.133H0Z" fill="none"/>
                                                            <path id="Path_359" data-name="Path 359"
                                                                  d="M5.165,6.665H12.2a.563.563,0,0,1,.541.583v5.833a.563.563,0,0,1-.541.583H3.541A.563.563,0,0,1,3,13.081V7.248a.563.563,0,0,1,.541-.583h.541V6.081A4.033,4.033,0,0,1,7,2.106a3.706,3.706,0,0,1,4.259,2.149l-.968.521A2.647,2.647,0,0,0,7.249,3.242a2.881,2.881,0,0,0-2.084,2.84ZM4.082,7.831V12.5h7.576V7.831Zm2.706,1.75H8.953v1.167H6.788Z"
                                                                  transform="translate(0.196 -0.171)" fill="#fff"/>
                                                        </svg>
                                                        {
                                                            sectionAmends.length >= 1 &&
                                                            <div className={'small-pill__span-item-counter'}>
                                                                {sectionAmends.length}
                                                            </div>
                                                        }

                                                    </div>

                                                }

                                            </div>
                                            }
                                            <div className={'small-pill__text'}>
                                                {section.name}
                                            </div>
                                            <div className={'small-pill__arrow'}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="6.792" height="11.412" viewBox="0 0 6.792 11.412">
                                                    <g id="Button_-_Arrow" data-name="Button - Arrow" transform="translate(0.706 0.706)">
                                                        <path id="Path_2" data-name="Path 2" d="M11.5,45.5l-5,5.586L1.5,45.5" transform="translate(-45.5 11.5) rotate(-90)" fill="none" stroke="#fcf7ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                                    </g>
                                                </svg>

                                            </div>

                                        </div>

                                    </SmallPill>
                                })}
                            </MediaQuery>
                        </div>


                    {section.blocks.map(block => {
                        const chunks = questionChunk(block.questions, 'text-input', q => q.small_input === true);
                        let title = '';

                        if (block.title == null) {
                            title = null;
                        } else {
                            if (block.show_section_number) {
                                title += `${block.number}) ${block.title}`;
                            } else {
                                title = block.title;
                            }
                        }

                        return (
                            <ApplicationSection title={title} description={ block.description}>

                                {chunks.map((chunk, index) => {
                                    return (
                                        <div key={index} className="grants-application-info__outer">
                                            {
                                                // For questions that are inputs we group together

                                                chunk.length > 1 ?
                                                    <div className="grants-application__row grants-application__info">
                                                        {chunk.map(question => this.renderQuestion(question, status, section, block))}
                                                    </div> :

                                                    chunk.map(question => this.renderQuestion(question, status, section, block))
                                            }
                                        </div>
                                    )
                                })}
                            </ApplicationSection>
                        )
                    })
                    }
                    {
                        this.isInProgress() &&
                        <div className="grants-application-info__outer">
                            <div className="grants-application__row grants-application__info"
                                 style={{gridTemplateColumns: 'repeat(2, 1fr)'}}>

                                <div className="grants-application-row__item">
                                    <p className="grants-application-row-item__title">Confirmation</p>
                                    <div className="section-content__container">
                                        <p className="section-content__label">I confirm that all details in this
                                            application have been entered correctly</p>
                                        <Checkbox text="Please tick to confirm" checked={this.state.confirmation}
                                                  onChange={this.setConfirmation.bind(this)}
                                                  error={!this.state.confirmation ? 'To submit you need to confirm' : null}/>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }

                </div>

                <div className="state-pages__navigation">
                    {
                        this.isInProgress() &&
                        <>
                            <ButtonPrevious hide={selectedPage == 0} onClick={backClick}>Back to
                                section {selectedPage}</ButtonPrevious>
                            <SaveButton onClick={this.onSubmit.bind(this)}>Submit And close</SaveButton>
                        </>

                    }
                    {

                        !this.isInProgress() && this.requiresAmending() &&
                        <ProceedButton onClick={this.onConfirmClick.bind(this)} color="green">Confirm
                            Changes</ProceedButton>
                    }
                </div>
            </>
        )
    }
}
